import React, { useState } from 'react';
import { Modal, View, Image, TouchableOpacity, TouchableWithoutFeedback, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/**
 * Room EQ / RF photo thumbnail that opens full screen when tapped (client list: "photo full screen").
 * Close with the X, a tap anywhere, or Escape (react-native-web's Modal calls onRequestClose).
 * The touchable stretches so a width: '100%' image keeps its width inside centered parents.
 */
export function RoomEqPhoto({ uri, style, description }) {
  const [open, setOpen] = useState(false);
  const label = description ? `Room EQ photo: ${description}` : 'Room EQ photo';

  if (!uri) return null;

  return (
    <>
      <TouchableOpacity
        activeOpacity={0.85}
        onPress={() => setOpen(true)}
        accessibilityRole="button"
        accessibilityLabel={`${label}. Open full screen`}
        style={[{ alignSelf: 'stretch' }, Platform.OS === 'web' ? { cursor: 'zoom-in' } : null]}
      >
        <Image source={{ uri }} style={style} resizeMode="contain" />
      </TouchableOpacity>
      <Modal visible={open} transparent animationType="fade" onRequestClose={() => setOpen(false)}>
        <TouchableWithoutFeedback onPress={() => setOpen(false)} accessibilityRole="button" accessibilityLabel="Close full screen photo">
          <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.95)', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <Image source={{ uri }} style={{ width: '100%', height: '100%' }} resizeMode="contain" accessibilityLabel={label} />
            <TouchableOpacity
              onPress={() => setOpen(false)}
              accessibilityRole="button"
              accessibilityLabel="Close"
              hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
              style={{ position: 'absolute', top: 20, right: 20, padding: 6, borderRadius: 20, backgroundColor: 'rgba(255,255,255,0.15)' }}
            >
              <Ionicons name="close" size={28} color="#FFFFFF" />
            </TouchableOpacity>
          </View>
        </TouchableWithoutFeedback>
      </Modal>
    </>
  );
}
